import {Alert, Button, TextInput} from "omoplay";
import {useState} from "react";
import {postCounsel} from "../../api/account/account.api";


const CounselForm = ({onPrev}) => {
    const [name, setName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [category, setCategory] = useState("")
    const [other, setOther] = useState("")

    return (
        <>
            <div className="flex-col gap-2">
                <div>담당자 이름</div>
                <TextInput placeholder="아이디를 입력해 주세요."
                           autoComplete="off"
                           value={name}
                           onChange={(e) => {
                               setName(e.currentTarget.value)
                           }} />
            </div>
            <div className="flex-col gap-2">
                <div>연락처</div>
                <TextInput placeholder="연락처를 입력해 주세요"
                           autoComplete="off"
                           value={phoneNumber}
                           onChange={(e) => {
                               setPhoneNumber(e.currentTarget.value)
                           }} />
            </div>
            <div className="flex-col gap-2">
                <div>업종</div>
                <TextInput placeholder="카페, 음식점"
                           autoComplete="off"
                           value={category}
                           onChange={(e) => {
                               setCategory(e.currentTarget.value)
                           }} />
            </div>
            <div className="flex-col gap-2">
                <div>오모플레이를 어떤 기능이 필요하신가요?</div>
                <TextInput placeholder="1초 회원가입 or 고객 데이터"
                           autoComplete="off"
                           value={other}
                           onChange={(e) => {
                               setOther(e.currentTarget.value)
                           }} />
            </div>
            <Alert title="어떻게 진행이 되나요?" type="info" withIcon={true}>
                <label className="text-[13px]">
                    담당자가 상담 신청에 남겨주신 내용을 기반으로 더 자세한 상담을 위해 연락 드리겠습니다.<br/>
                    고객 정보를 담기 위해 온라인 쇼핑몰을 생성해야 할 수도 있습니다.<br/>
                    (온라인 쇼핑몰은 무료로 누구나 쉽게 생성이 가능합니다.)
                </label>
            </Alert>
            <div className="flex justify-end w-full gap-2">
                <Button variants="outlined" value="이전" onClick={() => onPrev()} />
                <Button variants="primary" size="large" value="상담 신청"
                        onClick={() => {
                            postCounsel(name, phoneNumber, null, null, null, other, category).then(() => {
                                alert("상담이 요청되었습니다.")
                                window.location.href = "/services"
                            })
                        }}
                />
            </div>
        </>
    )
}

export default CounselForm